var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import DependencyStore from './DependencyStore';
import BaseController from './BaseController';
import Model from './Model';
import { Reaction } from './Reaction';
import { Tag } from 'function-tree';
import { ensureStrictPath, extractModuleProp, isComputedValue } from './utils';
import { Compute } from './Compute';

/*
  The controller is where everything is attached. The devtools
  is attached directly. Also a top level module is created.
  The controller creates the function tree that will run all sequences,
  based on top level providers and providers defined in modules
*/

var Controller = function (_BaseController) {
  _inherits(Controller, _BaseController);

  function Controller(rootModule, options) {
    _classCallCheck(this, Controller);

    var _this = _possibleConstructorReturn(this, (Controller.__proto__ || Object.getPrototypeOf(Controller)).call(this, rootModule, Object.assign({
      Model: Model
    }, options)));

    _this.dependencyStore = new DependencyStore();
    _this.flush = _this.flush.bind(_this);

    _this.on('asyncFunction', function (execution, funcDetails) {
      if (!funcDetails.isParallel) {
        _this.flush();
      }
    });
    _this.on('parallelStart', function () {
      return _this.flush();
    });
    _this.on('parallelProgress', function (execution, currentPayload, functionsResolving) {
      if (functionsResolving === 1) {
        _this.flush();
      }
    });
    _this.on('mutation', function (mutation) {
      return _this.updateComputed(mutation);
    });
    _this.on('end', function () {
      return _this.flush();
    });

    extractModuleProp(_this.module, 'reactions', function (reactions, currentModule) {
      if (reactions) {
        Object.keys(reactions).filter(function (key) {
          return reactions[key] instanceof Reaction;
        }).forEach(function (key) {
          return reactions[key].initialize();
        });
      }

      return reactions;
    });

    _this.getState = _this.getState.bind(_this);
    _this.getSequence = _this.getSequence.bind(_this);
    _this.getSequences = _this.getSequences.bind(_this);
    return _this;
  }

  /*
    Whenever components needs to be updated, this method
    can be called
  */


  _createClass(Controller, [{
    key: 'flush',
    value: function flush(force) {
      var changes = this.model.flush();

      if (!force && !changes.length) {
        return;
      }

      this.updateWatchers(changes, force);
      this.emit('flush', changes, Boolean(force));
    }

    /*
      Flags computed as dirty related to mutations
    */

  }, {
    key: 'updateComputed',
    value: function updateComputed(change) {
      var entities = this.dependencyStore.getUniqueEntities([change]);

      entities.forEach(function (entity) {
        if (entity instanceof Compute) {
          entity.isDirty = true;
        }
      });
    }
  }, {
    key: 'updateWatchers',
    value: function updateWatchers(changes, force) {
      var watchToUpdate = [];

      if (force) {
        watchToUpdate = this.dependencyStore.getAllUniqueEntities();
      } else {
        watchToUpdate = this.dependencyStore.getUniqueEntities(changes);
      }

      var startDateTime = Date.now();
      var start = typeof performance === 'undefined' ? Date.now() : performance.now();
      watchToUpdate.forEach(function (watch) {
        // We skip computed as they have already been flagged
        if (watch instanceof Compute) {
          return;
        }

        watch.onUpdate(changes, force);
      });
      var end = typeof performance === 'undefined' ? Date.now() : performance.now();

      if (this.devtools && watchToUpdate.length) {
        this.devtools.sendWatchMap(watchToUpdate, changes, startDateTime, end - start);
      }
    }

    /*
      Returns stuff based on tags/proxy
    */

  }, {
    key: 'get',
    value: function get(tag) {
      var overrideProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var context = this.createContext(overrideProps);
      var value = tag.getValue(context);

      if (isComputedValue(value)) {
        return value.getValue(overrideProps);
      }

      return value;
    }

    /*
      Create an object used to grab data from tags
    */

  }, {
    key: 'createContext',
    value: function createContext() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var modulePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      var modulePathString = modulePath.length ? modulePath.join('.') + '.' : '';

      return {
        props: props,
        controller: this,
        execution: {
          name: modulePathString
        }
      };
    }

    /*
      Creates a dependency map to be used with the store
    */

  }, {
    key: 'createDependencyMap',
    value: function createDependencyMap(dependencies, props, modulePath) {
      var _this2 = this;

      var getters = this.createContext(props, modulePath);

      return dependencies.reduce(function (currentDepsMap, dependency) {
        if (dependency instanceof Tag) {
          return dependency.getTags(getters).reduce(function (updatedCurrentDepsMap, tag) {
            if (tag.type === 'state' || tag.type === 'moduleState') {
              var value = tag.getValue(getters);

              if (isComputedValue(value)) {
                // We have to trigger the value to get the dependencyMap
                value.getValue(props);
                return Object.assign(updatedCurrentDepsMap, value.getDependencyMap());
              }

              var path = tag.getPath(getters);
              var strictPath = ensureStrictPath(path, _this2.getState(path));

              updatedCurrentDepsMap[strictPath] = true;
            }
            return updatedCurrentDepsMap;
          }, currentDepsMap);
        }
        return currentDepsMap;
      }, {});
    }
  }]);

  return Controller;
}(BaseController);

export default Controller;
//# sourceMappingURL=Controller.js.map